import React, { createContext, useContext, useState } from "react";

const AttendanceContext = createContext();

export const useAttendanceContext = () => {
  const context = useContext(AttendanceContext);
  if (!context) {
    throw new Error("useAttendanceContext debe usarse dentro de AttendanceProvider");
  }
  return context;
};

export const AttendanceProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    documentNumber: "",
    personalData: {},
    visitData: {},
    exitFeedback: {},
  });
  const [attendanceType, setAttendanceType] = useState(null); // 'entrada' | 'salida'

  const updateFormData = (section, data) => {
    setFormData(prev => ({
      ...prev,
      [section]: { ...prev[section], ...data }
    }));
  };

  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(1, prev - 1));
  };

  const resetForm = () => {
    setCurrentStep(1);
    setFormData({
      documentNumber: "",
      personalData: {},
      visitData: {},
      exitFeedback: {},
    });
    setAttendanceType(null);
  };

  const value = {
    currentStep,
    formData,
    attendanceType,
    setCurrentStep,
    setAttendanceType,
    updateFormData,
    nextStep,
    prevStep,
    resetForm,
  };

  return (
    <AttendanceContext.Provider value={value}>
      {children}
    </AttendanceContext.Provider>
  );
};